import get from "lodash-es/get";
import { useAssetDetailsContext } from "../../context/assetDetailsContext";
import { getAssetPath } from "../../../../shared/repository/mms-repository";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useGetAssetFullPath = ({ setIsLoading, setError }: Props) => {
	const {
		actions: { setAssetFullPath },
	} = useAssetDetailsContext();

	const GetAssetFullPath = async (assetId: string) => {
		setIsLoading(true);
		const res = await getAssetPath(assetId);
		if (res.ok) {
			const fullPath = get(res, "data.tables[0].rows[0].FullPath", "");
			setAssetFullPath(fullPath);
			setIsLoading(false);
		} else {
			setIsLoading(false);
			setError(res.message);
		}
	};

	return { GetAssetFullPath };
};
